import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
// import { set_isDirty } from 'redux/actions/AppActions'

const Confirmation = props => {
  const i18n = useTranslation();
  const dispatch = useDispatch();
  const theme = useSelector(state => state?.currentUser?.theme);

  const {
    open = false,
    setOpen,
    callback = new Function(),
    message = '',
    title = `${i18n.t('common.ARE_YOU_SURE')}`,
    JSX = false,
    okActionDisabled = false,
    // type = '',
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          // if (type == 'cancelConfirmation') {
          // 	new Function()
          // } else {
          handleClose();
          // }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={'sm'}
        sx={{
          minHeight: '400px',
        }}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              // type == 'cancelConfirmation'
              // 	? `${i18n.t(
              // 		'common.YOU_HAVE_SOME_UNSAVED_WORK_DO_YOU_STILL_WANT_TO_LEAVE_THE_PAGE'
              // 	)} ?`
              // 	:
              message
            }
          </DialogContentText>
          {typeof JSX === 'function' ? JSX() : ''}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="large"
            onClick={handleClose}
            sx={{
              color: theme === 'dark' ? 'white' : ' ',
              borderColor: theme === 'dark' ? 'white' : ' ',
            }}
          >
            {/* {type == 'cancelConfirmation'
								? i18n.t('common.GO_BACK')
								: type == 'appointmentCancellation'
									? i18n.t('common.GO_BACK') */}
            {i18n.t('common.CANCEL')}
          </Button>

          <Button
            variant="contained"
            size="large"
            onClick={() => {
              // if (type == 'unknown') {
              // 	setOpen(false)
              // } else {
              callback();
              // dispatch(set_isDirty(false))
              setOpen(false);
              // }
            }}
            disabled={okActionDisabled}
          >
            {/* {type == 'cancelConfirmation'
							? i18n.t('common.YES_LEAVE')
							: type == 'appointmentCancellation'
								? i18n.t('common.YES_CANCEL')
								: i18n.t('common.OK')} */}
            {i18n.t('common.OK')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default Confirmation;
